"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M39.5833 8.12496L31.6667 6.87496C30 6.66663 28.3333 7.08329 27.0833 8.12496L7.70835 23.9583C6.45835 25 5.83335 26.25 5.62501 27.9166C5.41668 29.375 5.83335 31.0416 6.87501 32.0833L14.5833 41.25C15.625 42.5 17.2917 43.3333 18.9583 43.3333C20.2083 43.3333 21.6667 42.9166 22.5 42.0833L41.875 26.25C43.125 25.2083 43.9583 23.5416 43.9583 22.0833L44.1667 14.1666C44.375 11.0416 42.5 8.54163 39.5833 8.12496ZM41.0417 21.875C41.0417 22.7083 40.625 23.3333 40 23.75L20.625 39.5833C19.5833 40.4166 17.7083 40.2083 16.875 39.1666L9.37501 29.7916C8.95835 29.1666 8.75001 28.5416 8.75001 27.9166C8.75001 27.2916 9.16668 26.6666 9.79168 26.25L29.1667 10.4166C29.7917 9.99996 30.625 9.79163 31.25 9.79163L39.1667 11.0416C40.4167 11.25 41.4583 12.5 41.25 13.75L41.0417 21.875Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.9583 14.5833C33.125 14.5833 32.5 14.7916 31.875 15.2083C30.625 16.25 30.4167 17.9166 31.4583 19.1666C32.0833 19.7916 32.9167 20.2083 33.75 20.2083C34.375 20.2083 35 20 35.625 19.5833C36.875 18.5416 37.0833 16.875 36.0417 15.625C35.4167 15 34.7917 14.7916 33.9583 14.5833ZM34.375 18.125C34.1667 18.3333 33.9583 18.3333 33.75 18.3333C33.5417 18.3333 33.125 18.125 33.125 17.9166C32.7083 17.5 32.9167 16.875 33.3333 16.6666C33.3333 16.6666 33.5417 16.4583 33.75 16.6666C33.9583 16.6666 34.1667 16.875 34.375 17.0833C34.7917 17.2916 34.5833 17.9166 34.375 18.125Z",
    fill: fill
  }));
};

exports["default"] = _default;